// @generated by protoc-gen-es v1.4.1 with parameter "target=ts+js+dts,import_extension=.mjs"
// @generated from file myplace/api/myplace.proto (package nautilus.myplace.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";

/**
 * @generated from enum nautilus.myplace.v1.Gender
 */
export const Gender = proto3.makeEnum(
  "nautilus.myplace.v1.Gender",
  [
    {no: 0, name: "GENDER_UNSPECIFIED"},
    {no: 1, name: "MALE"},
    {no: 2, name: "FEMALE"},
  ],
);

/**
 * @generated from enum nautilus.myplace.v1.SplashScreenMode
 */
export const SplashScreenMode = proto3.makeEnum(
  "nautilus.myplace.v1.SplashScreenMode",
  [
    {no: 0, name: "SPLASHSCREEN_MODE_UNSPECIFIED"},
    {no: 1, name: "SPLASHSCREEN_MODE_DISABLED"},
    {no: 2, name: "SPLASHSCREEN_MODE_TEXT"},
    {no: 3, name: "SPLASHSCREEN_MODE_IMAGE"},
    {no: 4, name: "SPLASHSCREEN_MODE_VIDEO"},
    {no: 5, name: "SPLASHSCREEN_MODE_SPINE"},
  ],
);

/**
 * @generated from message nautilus.myplace.v1.GetGameRequest
 */
export const GetGameRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.GetGameRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.GetGameReply
 */
export const GetGameReply = proto3.makeMessageType(
  "nautilus.myplace.v1.GetGameReply",
  () => [
    { no: 1, name: "game", kind: "message", T: Game },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListGamesRequest
 */
export const ListGamesRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.ListGamesRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListGamesReply
 */
export const ListGamesReply = proto3.makeMessageType(
  "nautilus.myplace.v1.ListGamesReply",
  () => [
    { no: 1, name: "games", kind: "message", T: Game, repeated: true },
    { no: 2, name: "categories", kind: "message", T: Category, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Game
 */
export const Game = proto3.makeMessageType(
  "nautilus.myplace.v1.Game",
  () => [
    { no: 1, name: "game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "slug", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "weight", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "version", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "status", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "orientations", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 10, name: "categories", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "labels", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 12, name: "image_92x92", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "image_264x264", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "image_243x224", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "image_320x468", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 16, name: "image_395x481", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "image_341x280", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Category
 */
export const Category = proto3.makeMessageType(
  "nautilus.myplace.v1.Category",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "order", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "show_tab", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListJackpotsRequest
 */
export const ListJackpotsRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.ListJackpotsRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListJackpotsReply
 */
export const ListJackpotsReply = proto3.makeMessageType(
  "nautilus.myplace.v1.ListJackpotsReply",
  () => [
    { no: 1, name: "jackpots", kind: "message", T: Jackpot, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Jackpot
 */
export const Jackpot = proto3.makeMessageType(
  "nautilus.myplace.v1.Jackpot",
  () => [
    { no: 1, name: "game_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "jackpot_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "balance", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListEventsRequest
 */
export const ListEventsRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.ListEventsRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListEventsReply
 */
export const ListEventsReply = proto3.makeMessageType(
  "nautilus.myplace.v1.ListEventsReply",
  () => [
    { no: 1, name: "events", kind: "message", T: Event, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Event
 */
export const Event = proto3.makeMessageType(
  "nautilus.myplace.v1.Event",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "promotion_banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "disable", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 8, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "start_date", kind: "message", T: Timestamp },
    { no: 10, name: "end_date", kind: "message", T: Timestamp },
    { no: 11, name: "on_click", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "rule_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "condition_ids", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 15, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListCustomerServicesRequest
 */
export const ListCustomerServicesRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.ListCustomerServicesRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListCustomerServicesReply
 */
export const ListCustomerServicesReply = proto3.makeMessageType(
  "nautilus.myplace.v1.ListCustomerServicesReply",
  () => [
    { no: 1, name: "accounts", kind: "message", T: CustomerService, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.CustomerService
 */
export const CustomerService = proto3.makeMessageType(
  "nautilus.myplace.v1.CustomerService",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "platform", kind: "enum", T: proto3.getEnumType(CustomerService_Platform) },
    { no: 3, name: "link", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(CustomerService_Status) },
  ],
);

/**
 * @generated from enum nautilus.myplace.v1.CustomerService.Platform
 */
export const CustomerService_Platform = proto3.makeEnum(
  "nautilus.myplace.v1.CustomerService.Platform",
  [
    {no: 0, name: "PLATFORM_UNKNOWN"},
    {no: 1, name: "FACEBOOK"},
    {no: 2, name: "TELEGRAM"},
    {no: 3, name: "ZALO"},
    {no: 4, name: "HOTLINE"},
    {no: 5, name: "LIVECHAT"},
    {no: 6, name: "FACEBOOK_FANPAGE"},
    {no: 7, name: "TELEGRAM_PROMOTION"},
    {no: 8, name: "ZALO_PROMOTION"},
  ],
);

/**
 * @generated from enum nautilus.myplace.v1.CustomerService.Status
 */
export const CustomerService_Status = proto3.makeEnum(
  "nautilus.myplace.v1.CustomerService.Status",
  [
    {no: 0, name: "STATUS_UNSPECIFIED"},
    {no: 1, name: "ACTIVE"},
    {no: 2, name: "INACTIVE"},
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListPopupsRequest
 */
export const ListPopupsRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.ListPopupsRequest",
  () => [
    { no: 1, name: "include_ended", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListPopupsReply
 */
export const ListPopupsReply = proto3.makeMessageType(
  "nautilus.myplace.v1.ListPopupsReply",
  () => [
    { no: 1, name: "popups", kind: "message", T: Popup, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Popup
 */
export const Popup = proto3.makeMessageType(
  "nautilus.myplace.v1.Popup",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "banner", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "btn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "on_click", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "action_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "start_date", kind: "message", T: Timestamp },
    { no: 9, name: "end_date", kind: "message", T: Timestamp },
    { no: 10, name: "index", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 11, name: "disabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 12, name: "condition_ids", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "rule_image", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 14, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListBasesRequest
 */
export const ListBasesRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.ListBasesRequest",
  () => [
    { no: 1, name: "gender", kind: "enum", T: proto3.getEnumType(Gender) },
    { no: 2, name: "random", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.ListBasesReply
 */
export const ListBasesReply = proto3.makeMessageType(
  "nautilus.myplace.v1.ListBasesReply",
  () => [
    { no: 1, name: "avatars", kind: "message", T: Avatar, repeated: true },
    { no: 2, name: "frames", kind: "message", T: Frame, repeated: true },
    { no: 3, name: "categories", kind: "message", T: FrameCategory, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Avatar
 */
export const Avatar = proto3.makeMessageType(
  "nautilus.myplace.v1.Avatar",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "gender", kind: "enum", T: proto3.getEnumType(Gender) },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Frame
 */
export const Frame = proto3.makeMessageType(
  "nautilus.myplace.v1.Frame",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "category", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 4, name: "unlocked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.FrameCategory
 */
export const FrameCategory = proto3.makeMessageType(
  "nautilus.myplace.v1.FrameCategory",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.GetBootstrapConfigRequest
 */
export const GetBootstrapConfigRequest = proto3.makeMessageType(
  "nautilus.myplace.v1.GetBootstrapConfigRequest",
  () => [
    { no: 1, name: "tenant_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "lang", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.SplashScreen
 */
export const SplashScreen = proto3.makeMessageType(
  "nautilus.myplace.v1.SplashScreen",
  () => [
    { no: 1, name: "mode", kind: "enum", T: proto3.getEnumType(SplashScreenMode) },
    { no: 2, name: "path", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.GetBootstrapConfigReply
 */
export const GetBootstrapConfigReply = proto3.makeMessageType(
  "nautilus.myplace.v1.GetBootstrapConfigReply",
  () => [
    { no: 1, name: "api_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "resource_domain", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "jackpot_interval_seconds", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 4, name: "maintenance", kind: "message", T: Maintenance },
    { no: 5, name: "agent_enabled", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: "logo", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "favicon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "splash_screen", kind: "message", T: SplashScreen },
    { no: 10, name: "supported_languages", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 11, name: "supported_currencies", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ],
);

/**
 * @generated from message nautilus.myplace.v1.Maintenance
 */
export const Maintenance = proto3.makeMessageType(
  "nautilus.myplace.v1.Maintenance",
  () => [
    { no: 1, name: "starts_at", kind: "message", T: Timestamp },
    { no: 2, name: "ends_at", kind: "message", T: Timestamp },
    { no: 3, name: "message", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "active", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ],
);

